/**
 * Cards block client-side JavaScript.
 *
 * @package LeylineNexus\Theme
 */

(function () {
	'use strict';

	/**
	 * Initialize load more functionality for cards blocks.
	 */
	function initCardsLoadMore() {
		const loadMoreButtons = document.querySelectorAll('[data-cards-load-more]');

		loadMoreButtons.forEach(function (button) {
			button.addEventListener('click', handleLoadMore);
		});
	}

	/**
	 * Handle load more button click.
	 *
	 * @param {Event} event - Click event.
	 */
	function handleLoadMore(event) {
		const button = event.currentTarget;
		const block = button.closest('[data-cards-lazy-load]');
		const container = block.querySelector('[data-cards-container]');

		if (!container || button.disabled) {
			return;
		}

		const offset = parseInt(button.dataset.offset, 10) || 0;
		const columns = parseInt(button.dataset.columns, 10) || 3;
		const excludeId = parseInt(button.dataset.exclude, 10) || 0;
		const nonce = button.dataset.nonce || '';

		// Disable button and show loading state.
		button.disabled = true;
		const originalText = button.textContent;
		button.textContent = 'Loading...';

		const formData = new FormData();
		formData.append('action', 'load_more_cards');
		formData.append('nonce', nonce);
		formData.append('offset', offset);
		formData.append('columns', columns);
		formData.append('exclude_id', excludeId);

		fetch(leylinenexus_variables.ajax_url, {
			method: 'POST',
			body: formData,
			credentials: 'same-origin'
		})
			.then(function (response) {
				return response.json();
			})
			.then(function (data) {
				if (data.success && data.data.html) {
					// Create a temporary container to parse the HTML.
					const temp = document.createElement('div');
					temp.innerHTML = data.data.html;

					// Append new cards to the container.
					while (temp.firstChild) {
						container.appendChild(temp.firstChild);
					}

					// Refresh AOS animations for new elements.
					if (typeof AOS !== 'undefined') {
						AOS.refresh();
					}

					// Update offset for next load.
					button.dataset.offset = data.data.new_offset;

					// Hide button if no more posts.
					if (!data.data.has_more) {
						button.parentElement.remove();
					} else {
						button.disabled = false;
						button.textContent = originalText;
					}
				} else {
					button.disabled = false;
					button.textContent = originalText;
				}
			})
			.catch(function () {
				button.disabled = false;
				button.textContent = originalText;
			});
	}

	// Initialize when DOM is ready.
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initCardsLoadMore);
	} else {
		initCardsLoadMore();
	}
})();
